import { render, staticRenderFns } from "./FakeLanding.vue?vue&type=template&id=7c1a9b1c&"
import script from "./FakeLanding.vue?vue&type=script&lang=js&"
export * from "./FakeLanding.vue?vue&type=script&lang=js&"
import style0 from "./FakeLanding.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports